import { theme as legacyTheme } from '../component-library';
import { theme as theme2022 } from '../2022-component-library';
import { client } from './api-client';

export const getCustomTheme = async () => {
  try {
    const customTheme = await client('api/theme/active/');
    if (!customTheme?.id) return null;
    legacyTheme.colors.primary = customTheme.primary_color;
    legacyTheme.colors.secondary = customTheme.secondary_color;
    legacyTheme.colors.gradient = `linear-gradient(90deg, ${customTheme.primary_color} 0%, ${customTheme.secondary_color} 100%)`;
    theme2022.colors.primary = customTheme.primary_color;
    theme2022.colors.secondary = customTheme.secondary_color;
    theme2022.colors.gradient = ` linear-gradient(138.24deg, ${customTheme.primary_color} -6.34%, ${customTheme.secondary_color} 100%)',`;
    const faviconElement = document.querySelector('link[rel="icon"]');
    const appleFaviconElement = document.querySelector('link[rel="apple-touch-icon"]');
    if (faviconElement) faviconElement.href = customTheme.favicon;
    if (appleFaviconElement) appleFaviconElement.href = customTheme.favicon;
  } catch (error) {}
};
